/* Drømmemøbler – Gruppebyggeren, del 3: velger, regler og handlekurv. Krever dm-gruppebygger-katalog.js og dm-gruppebygger-plan.js. */
(function () {
  'use strict';
  var root = document.querySelector('[data-dmgb]');
  if (!root || root.dataset.dmgbReady || !window.DMGB || !DMGB.bygg) return;
  root.dataset.dmgbReady = '1';

  var RAW;
  try { RAW = JSON.parse(root.querySelector('[data-dmgb-data]').textContent); }
  catch (e) { root.querySelector('[data-dmgb-picker]').innerHTML = '<p class="dmgb-empty">Gruppebyggeren kunne ikke lastes. Ring oss på 907 00 777, så hjelper vi deg.</p>'; return; }

  var K = DMGB.bygg(RAW), ALL = K.ALL, LOUNGE = K.LOUNGE, DINING = K.DINING, MIN_CHAIRS = K.MIN_CHAIRS, esc = K.esc, kr = K.kr;
  var $ = function (s) { return root.querySelector(s); };

  /* ---------- tilstand ---------- */
  var mode = /spise|dining/.test(location.hash) ? 'dining' : 'lounge';
  var state = { lounge: {}, dining: {} };
  function q(id) { return state[mode][id] || 0; }
  function setQ(id, n) { if (n <= 0) delete state[mode][id]; else state[mode][id] = n; }
  function sel(kinds) { return Object.keys(state[mode]).filter(function (id) { return kinds.indexOf(ALL[id].kind) > -1; }).map(function (id) { return { o: ALL[id], n: state[mode][id] }; }); }
  function sum(kinds) { return sel(kinds).reduce(function (s, x) { return s + x.n; }, 0); }
  function flat(kinds) { var a = []; sel(kinds).forEach(function (x) { for (var i = 0; i < x.n; i++) a.push(x.o); }); return a; }
  function inStockFirst(a) { return a.slice().sort(function (x, y) { return (y.stock > 0) - (x.stock > 0); }); }

  /* ---------- kort ---------- */
  function pill(o) {
    if (o.stock <= 0) return '<span class="dmgb-pill dmgb-pill--bad">Ikke på lager</span>';
    if (o.stock <= 5) return '<span class="dmgb-pill dmgb-pill--low">Få igjen · ' + o.stock + '</span>';
    return '<span class="dmgb-pill dmgb-pill--ok">På lager</span>';
  }
  function media(o) {
    return '<a class="dmgb-img" href="' + esc(o.url) + '" target="_blank" rel="noopener" aria-label="Se ' + esc(o.name) + ' (åpnes i ny fane)">' +
      (o.img ? '<img src="' + esc(o.img) + '" alt="" loading="lazy" width="520" height="390">' : '') + '</a>';
  }
  function qtyCard(o, opt) {
    opt = opt || {};
    var n = q(o.id), out = o.stock <= 0, block = !out && opt.block, maxed = n >= o.stock || (opt.max != null && n >= opt.max);
    var foot;
    if (out) foot = '<p class="dmgb-why">Kan ikke velges nå</p>';
    else if (block && !n) foot = '<p class="dmgb-why">' + esc(opt.block) + '</p>';
    else foot = '<div class="dmgb-qty"><button type="button" data-id="' + esc(o.id) + '" data-d="-1"' + (n ? '' : ' disabled') + ' aria-label="Færre ' + esc(o.name) + '">−</button>' +
      '<output>' + n + '</output><button type="button" data-id="' + esc(o.id) + '" data-d="1"' + (maxed || block ? ' disabled' : '') + ' aria-label="Flere ' + esc(o.name) + '">+</button></div>';
    return '<div class="dmgb-card' + (n ? ' is-sel' : '') + (out ? ' is-out' : '') + (block && !n ? ' is-blocked' : '') + '">' + media(o) +
      '<div class="dmgb-card-body"><p class="dmgb-name">' + esc(o.name) + '</p>' + (o.note ? '<p class="dmgb-note">' + esc(o.note) + '</p>' : '') + (opt.sub ? '<p class="dmgb-note">' + esc(opt.sub) + '</p>' : '') +
      '<div class="dmgb-meta"><span class="dmgb-price">' + kr(o.price) + '</span>' + pill(o) + '</div>' + foot + '</div></div>';
  }
  function pickCard(o, group, opt) {
    opt = opt || {};
    var n = q(o.id), out = o.stock <= 0;
    var foot = out ? '<p class="dmgb-why">Kan ikke velges nå</p>' :
      '<button type="button" class="dmgb-pick" data-pick="' + esc(o.id) + '" data-group="' + group + '" aria-pressed="' + (n ? 'true' : 'false') + '">' + (n ? 'Valgt ✓' : 'Velg') + '</button>';
    return '<div class="dmgb-card' + (n ? ' is-sel' : '') + (out ? ' is-out' : '') + '">' + media(o) +
      '<div class="dmgb-card-body"><p class="dmgb-name">' + esc(o.name) + '</p>' + (o.note ? '<p class="dmgb-note">' + esc(o.note) + '</p>' : '') + (opt.sub ? '<p class="dmgb-note">' + esc(opt.sub) + '</p>' : '') +
      '<div class="dmgb-meta"><span class="dmgb-price">' + kr(o.price) + '</span>' + pill(o) + '</div>' + foot + '</div></div>';
  }
  function cards(list, fn) { return list.length ? '<div class="dmgb-cards">' + inStockFirst(list).map(fn).join('') + '</div>' : '<p class="dmgb-empty">Ingen varer her akkurat nå.</p>'; }
  function step(no, title, note, body) {
    return '<section class="dmgb-step"><div class="dmgb-step-head"><span class="dmgb-step-no">Steg ' + no + '</span><h2>' + title + '</h2></div>' +
      (note ? '<p class="dmgb-step-note">' + note + '</p>' : '') + body + '</section>';
  }
  function sub(title, list, fn) { return '<h3 class="dmgb-sub">' + title + '</h3>' + cards(list, fn); }

  function renderLounge() {
    var seats = '';
    seats += sub('3-seter sofaer', LOUNGE.sofa3, function (o) { return qtyCard(o); });
    if (LOUNGE.sofa2.length) seats += sub('2-seter sofaer', LOUNGE.sofa2, function (o) { return qtyCard(o); });
    if (LOUNGE.corner.length) seats += sub('Hjørnesofaer', LOUNGE.corner, function (o) { return qtyCard(o, { max: 1 }); });
    seats += sub('Loungestoler', LOUNGE.chair, function (o) { return qtyCard(o); });
    return step(1, 'Sitteplasser', 'Kombiner fritt: 3+3, 3+2, 2+2, 3+1+1, hjørnesofa eller flere stoler. Gruppen må ha minst to sofaer, én sofa og to stoler, eller en hjørnesofa.', seats) +
      step(2, 'Loungebord', 'Velg ett bord eller bordsett. Gruppen kan ikke bestilles uten bord.', cards(LOUNGE.table, function (o) { return pickCard(o, 'ltable'); })) +
      (LOUNGE.extra.length ? step(3, 'Puffer og sidebord', 'Valgfritt. Kan bare bestilles sammen med en komplett gruppe.', cards(LOUNGE.extra, function (o) { return qtyCard(o); })) : '');
  }
  function renderDining() {
    var t = (sel(['dtable'])[0] || {}).o, ch = sum(['dchair']);
    var note2 = (t ? esc(t.name) + ' har plass til ' + Math.min(MIN_CHAIRS, t.seats) + '–' + t.seats + ' stoler. Du har valgt ' + ch + '.' :
      'Velg bord først. Spisegrupper selges med minst ' + MIN_CHAIRS + ' stoler.') + ' Du kan blande modeller.';
    return step(1, 'Spisebord', 'Bordet bestemmer hvor mange stoler som får plass, og om du trenger vanlige stoler eller lave loungespisestoler.',
        cards(DINING.table, function (o) { return pickCard(o, 'dtable', { sub: (o.h === 'low' ? 'Lav loungehøyde' : 'Vanlig spisehøyde') + ' · inntil ' + o.seats + ' stoler' }); })) +
      step(2, 'Spisestoler', note2, cards(DINING.chair, function (o) {
        var block = null;
        if (!t) block = 'Velg bord først';
        else if (o.h !== t.h) block = o.h === 'low' ? 'For lav til dette bordet' : 'For høy til dette lave bordet';
        var room = t ? t.seats - ch + q(o.id) : 0;
        return qtyCard(o, { block: block, max: room, sub: o.h === 'low' ? 'Lav loungespisestol' : '' });
      }));
  }

  /* ---------- regler ---------- */
  function rules() {
    if (mode === 'lounge') {
      var s3 = sum(['sofa3']), s2 = sum(['sofa2']), c = sum(['corner']), ch = sum(['chair']), tb = sum(['ltable']), sofas = s3 + s2;
      var ok = c >= 1 || sofas >= 2 || (sofas >= 1 && ch >= 2), label;
      var stoler = function (k) { return k + ' stol' + (k === 1 ? '' : 'er'); };
      if (c) label = 'Hjørnesofa valgt' + (ch ? ' + ' + stoler(ch) : '');
      else if (sofas >= 2) label = [s3 ? s3 + '× 3-seter' : '', s2 ? s2 + '× 2-seter' : ''].filter(Boolean).join(' + ') + (ch ? ' + ' + stoler(ch) : '');
      else if (sofas === 1) label = ch >= 2 ? 'Sofa + ' + stoler(ch) : 'Sofa' + (ch ? ' + ' + stoler(ch) : '') + ' – legg til én sofa til eller ' + stoler(2 - ch);
      else label = ch ? stoler(ch) + ' – legg til minst én sofa' : 'Velg sofaer, stoler eller hjørnesofa';
      return [[ok, ok ? 'Komplett sittegruppe: ' + label : label], [tb === 1, tb ? 'Loungebord valgt' : 'Velg loungebord']];
    }
    var t = (sel(['dtable'])[0] || {}).o, n = sum(['dchair']), min = t ? Math.min(MIN_CHAIRS, t.seats) : MIN_CHAIRS, models = sel(['dchair']).length;
    var r = [[!!t, t ? t.name : 'Velg spisebord'],
      [!!t && n >= min && n <= t.seats, !t ? 'Minst ' + MIN_CHAIRS + ' stoler' : n < min ? n + ' av minst ' + min + ' stoler valgt' : n + ' stoler (plass til ' + t.seats + ')']];
    if (models > 1) r.push([true, models + ' stolmodeller blandet']);
    return r;
  }

  /* ---------- tegn ---------- */
  var picker = $('[data-dmgb-picker]'), cta = $('[data-dmgb-cta]'), err = $('[data-dmgb-err]'), bar = $('[data-dmgb-bar]');
  var complete = false;
  function render(focusKey) {
    picker.innerHTML = mode === 'lounge' ? renderLounge() : renderDining();
    $('[data-dmgb-plan]').innerHTML = mode === 'lounge'
      ? DMGB.planLounge({ tbl: (sel(['ltable'])[0] || {}).o, sofas: flat(['sofa3', 'sofa2']), corner: flat(['corner'])[0], chairs: flat(['chair']), extras: flat(['puff', 'side']) })
      : DMGB.planDining((sel(['dtable'])[0] || {}).o, flat(['dchair']));
    $('[data-dmgb-sum-h]').textContent = mode === 'lounge' ? 'Din loungegruppe' : 'Din spisegruppe';
    var rs = rules(); complete = rs.every(function (r) { return r[0]; });
    $('[data-dmgb-rules]').innerHTML = rs.map(function (r) { return '<li class="' + (r[0] ? 'is-ok' : '') + '"><i aria-hidden="true">' + (r[0] ? '✓' : '') + '</i><span>' + esc(r[1]) + '</span></li>'; }).join('');
    var chosen = Object.keys(state[mode]).map(function (id) { return { o: ALL[id], n: state[mode][id] }; });
    $('[data-dmgb-lines]').innerHTML = chosen.map(function (x) { return '<li><span>' + x.n + '× ' + esc(x.o.name) + '</span><span>' + kr(x.o.price * x.n) + '</span></li>'; }).join('');
    var total = chosen.reduce(function (s, x) { return s + x.o.price * x.n; }, 0);
    $('[data-dmgb-total]').textContent = kr(total);
    cta.disabled = !complete; cta.textContent = complete ? 'Legg gruppen i handlekurven' : 'Fullfør gruppen for å bestille';
    err.hidden = true;
    bar.hidden = !chosen.length;
    $('[data-dmgb-bar-total]').textContent = kr(total);
    $('[data-dmgb-bar-status]').textContent = complete ? 'Gruppen er komplett' : (rs.filter(function (r) { return !r[0]; })[0] || [0, ''])[1];
    root.querySelectorAll('[role="tab"]').forEach(function (b) { b.setAttribute('aria-selected', b.dataset.mode === mode ? 'true' : 'false'); });
    if (focusKey) { var el = picker.querySelector(focusKey); if (el && !el.disabled) el.focus({ preventScroll: true }); }
  }

  picker.addEventListener('click', function (e) {
    var b = e.target.closest('button'); if (!b || b.disabled) return;
    if (b.dataset.d) {
      var id = b.dataset.id, o = ALL[id], n = q(id) + +b.dataset.d; if (n > o.stock) return;
      setQ(id, n); render('button[data-id="' + id + '"][data-d="' + b.dataset.d + '"]');
    } else if (b.dataset.pick) {
      var pid = b.dataset.pick, g = b.dataset.group, was = q(pid);
      Object.keys(state[mode]).forEach(function (k) { if (ALL[k].kind === g) delete state[mode][k]; });
      if (!was) state[mode][pid] = 1;
      if (g === 'dtable') {
        var t = (sel(['dtable'])[0] || {}).o;
        Object.keys(state[mode]).forEach(function (k) { if (ALL[k].kind === 'dchair' && (!t || ALL[k].h !== t.h)) delete state[mode][k]; });
        if (t) {
          var extra = sum(['dchair']) - t.seats;
          Object.keys(state[mode]).reverse().forEach(function (k) {
            if (extra > 0 && ALL[k].kind === 'dchair') { var cut = Math.min(extra, state[mode][k]); state[mode][k] -= cut; extra -= cut; if (!state[mode][k]) delete state[mode][k]; }
          });
        }
      }
      render('button[data-pick="' + pid + '"]');
    }
  });
  root.querySelectorAll('[role="tab"]').forEach(function (b) {
    b.addEventListener('click', function () { mode = b.dataset.mode; try { history.replaceState(null, '', mode === 'dining' ? '#spisegruppe' : '#loungegruppe'); } catch (e) {} render(); });
  });
  $('[data-dmgb-reset]').addEventListener('click', function () { state[mode] = {}; render(); });
  $('[data-dmgb-bar-go]').addEventListener('click', function () { $('[data-dmgb-sum]').scrollIntoView({ behavior: 'smooth', block: 'start' }); });

  cta.addEventListener('click', function () {
    if (!complete) return;
    var label = (mode === 'lounge' ? 'Loungegruppe ' : 'Spisegruppe ') + new Date().toISOString().slice(0, 16).replace('T', ' ');
    var agg = {};
    Object.keys(state[mode]).forEach(function (id) { ALL[id].parts.forEach(function (p) { agg[p.v] = (agg[p.v] || 0) + state[mode][id]; }); });
    var items = Object.keys(agg).map(function (v) { return { id: +v, quantity: agg[v], properties: { _gruppebygger: label } }; });
    cta.disabled = true; cta.textContent = 'Legger i handlekurven …'; err.hidden = true;
    fetch((RAW.cart_add_url || '/cart/add') + '.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest', 'X-DMHG': '1' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { window.location.href = RAW.cart_url || '/cart'; })
      .catch(function (e) {
        cta.disabled = false; cta.textContent = 'Legg gruppen i handlekurven';
        err.textContent = ((e && e.description) || 'Gruppen kunne ikke legges i handlekurven') + '. Prøv igjen, eller ring oss på 907 00 777.';
        err.hidden = false;
      });
  });

  render();
})();